module.exports = __webpack_public_path__ + "static/media/shared-space.0ebb9f6c.jpg";